
export const impact = state =>{
  return state.impact;
}

export const impactPayload = state =>{
  return state.impactPayload;
}

export const personImpactCount = state => {
  if(state.impact !=null){
  return state.impact.length;}
  return null;

}

export const projectAliasesLive = state =>{
  return state.projectAliasesLive;
}

export const personNotes = state =>{
  return state.personNotes;
}

export const personNotesCount = state =>{
  return state.personNotes.length
}
export const peopleAttendingToday = state =>{
return state.peopleAttendingToday
};

export const projectOptions =state=>{
return state.projectOptions
};

export const project = state=>{
    return state.project;
};

export const projectList = state=>{
  return state.projectList;
};

export const peopleList = state => {
  return state.peopleList;
};

export const djangoToken = state => {
  return state.djangoToken;
};
export const person = state => {
  return state.person;
};

export const addedFriend = state => {
  return state.dataFromSearch.addedFriend;
};

export const urlPrefix = state => {
  return state.urlPrefix;
};

export const axiosError = state => {
  return state.axiosError;
};

export const email = state => {
  return state.email;
};

export const phone = state => {
  return state.phone;
};

export const showHideElement = state => {
  return state.showHideElement;
};

export const fnf = state => {
  return state.fnf;
};

export const fnfOptions = state => {
  return state.fnfOptions;
};

export const fnfEditData = state => {
  return state.fnfEditData;
};

export const reportData = state => {
  return state.reportData;
};

export const loadingData = state => {
  return state.loadingData;
};